import { createSelector } from "reselect"
import type { OutputSelector } from "reselect"

import { getAffiliateThisSession, getBrandingAffilId, getRawAffilId } from "./reducer"
import { getUserAffilId } from "../user/userSelectors"
import { getAffilidAccordingToPriority } from "../affilId/tools"
import { isTequila } from "@kiwicom/nitro/lib/services/platform/shared"

type State = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  options: any
}

type OptionsInstance = State["options"]

export const optionsSelector = (state: State): OptionsInstance => state.options

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const languageSelector: OutputSelector<State, any, string> = createSelector(
  optionsSelector,
  (options) => options.language,
)

// Affiliate settings
// ===

// The only proper way how get affilid
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getAffilId: any = createSelector(
  getAffiliateThisSession,
  getRawAffilId,
  getUserAffilId,
  getBrandingAffilId,
  getAffilidAccordingToPriority,
)

// @deprecated use `isTequila` from `useSSRFlags` instead.
export const isTequilaSelector: OutputSelector<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  boolean,
  (options: OptionsInstance) => boolean
> = createSelector(optionsSelector, isTequila)
